import './main.less';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import renderViewsState from '../../shared/render-views-state';
import Animate from '../../shared/animation';

import EditForm from '../components/form';
import { selectors as rootSelectors } from '../../root';

const Main = renderViewsState(props => (
	<Animate>
		<div className="container__content admin-profile">
			<div className="container__content-body">
				<EditForm {...props} initialValues={props.data} enableReinitialize={true} isProfile={true} />
			</div>
		</div>
	</Animate>
));

export default connect(
	state => ({
		data: selectors.getData(state),
		timezoneOptions: selectors.getTimezoneOptions(state),
		progressBar: selectors.getProgressBar(state),
		menuConfig: rootSelectors.getMenuConfig(state),
		error: selectors.getError(state),
		intl: selectors.getIntl(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/admins/profile/main.js